export default {
  'sidebar.sectionTitle.annotation-tool': 'Annotation platform',
  'sidebar.annotation-dashboard': 'Annotation Dashboard',
  'sidebar.annotation': 'Annotator Workspace',
  'sidebar.annotation-supervisor': 'Supervisor Workspace',
  'sidebar.administration-workspace': 'Administration Workspace',
  'sidebar.admin-projects': 'Manage Projects',
  'sidebar.annotator-queue': 'My Assignments',
  'sidebar.annotation-supervisor-queue': 'Review Conflicts',
  // Nested feature labels under Supervisor Workspace
  'sidebar.annotation-supervisor.supervisor-projects': 'My Projects',
  'sidebar.annotation-supervisor.annotation-supervisor': 'Review Conflicts',
  'sidebar.annotation-supervisor.annotator-queue': 'My Assignments',
  // Nested feature labels under Annotator Workspace
  'sidebar.annotation.annotator-queue': 'My Assignments',
  // Nested feature labels under Administration Workspace
  'sidebar.administration-workspace.admin-projects': 'Manage Projects',
  'sidebar.annotation.annotator-projects': 'My Projects',
  'sidebar.metrics': 'Metrics',
  'sidebar.metrics.dashboard': 'Dashboard',
  'sidebar.metrics.summary': 'Summary',
  'sidebar.metrics.encounterStats': 'Encounter statistics',
  'sidebar.metrics.irrScore': 'F1 score',
  'sidebar.metrics.holidays': 'Holidays',
};
